/** A folder's conversation (its tab): comments about the folder, seen by whoever sees it. */
import type { Conversation, SpaceOut } from "../../api/types.gen.ts";
import { t } from "../../i18n/index.ts";
import type { Resource } from "../../lib/resource.ts";
import { Thread } from "../comments/thread.tsx";

export function FolderConversation({ space, id, conv }: { space: SpaceOut; id: string; conv: Resource<Conversation> }) {
  return (
    <div class="flex max-w-3xl flex-col gap-8">
      <Thread space={space} topic={{ folder: id }} conv={conv} at={{}} empty={t("comments.none")} />
    </div>
  );
}
